export default "__VITE_ASSET__8875aec5__"